import React, {useLayoutEffect, useState} from 'react';

import LeftHeader from '../../generals-components/headers/centred-header';
import ChangelogsPageMain from './components/main';
import Footer from '../../generals-components/footer/footer';

async function checkUserSession() {
    const response = await fetch('/api/check-token', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        return true;
    } else {
        return false;
    }
}

function ChangelogsPage() {
    const [isUserLogged, setIsUserLogged] = useState(false)

    useLayoutEffect(() => {
        async function checkIfUserIsLogged() {
            setIsUserLogged(await checkUserSession())
        }

        checkIfUserIsLogged()
    }, [])

    useLayoutEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="bg-background-light dark:bg-background-dark font-display text-slate-900 dark:text-white selection:bg-primary/30 carbon-bg">
            <LeftHeader isUserLogged={isUserLogged} setIsUserLogged={setIsUserLogged} currentPage={"Changelogs"}/>
            <ChangelogsPageMain/>
            <Footer currentPage={"Software Changelogs"}/>
        </div>
    );
}


export default ChangelogsPage;